import React from 'react'

import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import { withStyles, createStyles, WithStyles, Theme } from '@material-ui/core'

import { MatchesResponse } from 'protos'

import { format } from 'date-fns'

import FancyDivider from 'components/FancyDivider'
import MatchCompetitionGroup from './components/MatchCompetitionGroup'

interface Props {
  dateGroup: MatchesResponse.IDateGroup
  onMatchSelect: (matchId: string) => void
}

const styles = (theme: Theme) => createStyles({
  root: {
    padding: theme.spacing(),
    marginTop: theme.spacing(),
  },
})

type InjectedProps = Props & WithStyles<typeof styles>

const MatchDateGroup: React.SFC<InjectedProps> = ({ classes, dateGroup, onMatchSelect }) => {
  if (!dateGroup.competition) {
    return null
  }

  return (
    <div className={classes.root}>
      <FancyDivider>
        {format(Number(dateGroup.date) * 1000, 'iiii do LLLL')}
      </FancyDivider>

      <List>
        {dateGroup.competition.map((competition, i) => (
          <ListItem disableGutters key={i}>
            <MatchCompetitionGroup
              competition={competition}
              onMatchSelect={onMatchSelect}
            />
          </ListItem>
        ))}
      </List>
    </div>
  )
}

export default withStyles(styles)(MatchDateGroup)
